module.exports = __webpack_public_path__ + "img/selfie_stick.9baa0660.jpg";